<template>
    <div class="web">
        <Header :type="'consultores'"></Header>
        <main class="py-5 consultores">

            <!-- Consultor SAP independiente -->
            <div class="mb-5 top-section" :style="{ 'background': 'linear-gradient(0deg, rgba(255, 255, 255, 0.35), rgba(255, 255, 255, 0.35)), center /  34% 90% no-repeat url('+urlWeb+'/assets/images/fotos/11.png)' }">
                <div class="d-flex flex-row justify-content-between">
                    <div class="text-center">
                        <h2 class="strong text-grey mb-4 text-center title">Únete a nuestra plataforma y conecta con empresas para
                            ofrecer tus servicios como</h2>

                        <h2 class="bg-orange h1 text-light-grey py-3">
                            Consultor SAP<br />
                            independiente
                        </h2>

                        <div class="d-flex align-items-center justify-content-center py-5">
                            <div>
                                <img :src="urlWeb + '/assets/images/logos/money.png'" >
                            </div>
                            <div class="consultores-text" style="text-align: justify;">
                                Te brindamos la oportunidad de obtener mayores ingresos ofreciendo tus servicios de
                                consultoría en línea.
                            </div>
                        </div>
                        <div class=" text-right pb-5 mr-4">
                            <router-link to="/Registro" class="btn btn-subscribe-lg">Suscríbete</router-link>
                        </div>
                    </div>
                    <div class=""></div>
                    <div class=" text-center">
                        <div class=" d-flex align-items-center justify-content-center py-5">
                            <div >
                                <img :src="urlWeb + '/assets/images/logos/tablet.png'">
                            </div>
                            <div class="consultores-text" style="text-align: justify;">
                                Los consultores de SAP tienen una gran demanda en todo el mundo debido a la complejidad y la
                                importancia de los sistemas SAP, además de obtener muy buenas remuneraciones en base a su
                                experiencia.
                            </div>
                        </div>
                        <div class=" d-flex align-items-center justify-content-center py-5">
                            <div class="consultores-text" style="text-align: justify;">
                                En <strong class="text-grey">its<span class="text-orange">SAP</span>p</strong> encontrarás
                                la libertad de trabajar desde cualquier lugar y en el horario que
                                mejor te convenga al tener acceso a una variada oferta de proyectos y clientes en diferentes
                                industrias y localidades.
                            </div>
                            <div >
                                <img :src="urlWeb + '/assets/images/logos/icon- lap top.png'">
                            </div>
                        </div>
                        <hr />
                    </div>
                </div>
            </div>

            

            <!-- Te contamos algunas historias -->
            <div class="container mb-5">
                <div class="row mb-4">
                    <div class="col-12 text-end">
                        <h1 class="text-grey strong text-center">¡Te contamos <span class="bg-orange px-3">algunas historias!</span>
                        </h1>
                    </div>
                </div>

                <div class="d-flex flex-row">
                    <div class="p-5">
                        <div>
                            <div>
                                <iframe width="100%"
                                    src="https://www.youtube.com/embed/8WASpdvqsLQ?si=zJ805Sxlkg1rVFcy"
                                    title="YouTube video player" frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                    <div class="p-5">
                        <div>
                            <div>
                                <iframe width="100%"
                                    src="https://www.youtube.com/embed/fv8pCjmsPQ8?si=L3Yo8rYmmNgBdPXZ"
                                    title="YouTube video player" frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                    <div class="p-5">
                        <div>
                            <div>
                                <iframe width="100%"
                                    src="https://www.youtube.com/embed/bZSufvdE3kE?si=ZAZtBzzGZwxknKwi"
                                    title="YouTube video player" frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex flex-row">
                    <div class="p-5">
                        <div>
                            <div>
                                <iframe width="100%"
                                    src="https://www.youtube.com/embed/dC5Fkn2CzsI?si=iV9TZq8RWh9lguPx"
                                    title="YouTube video player" frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                    <div class="p-5">
                        <div>
                            <div>
                                <iframe width="100%"
                                    src="https://www.youtube.com/embed/HQfqKJYQjNc?si=Ho60B7SGkCT1fTag"
                                    title="YouTube video player" frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                    <div class="p-5">
                        <div>
                            <div>
                                <iframe width="100%"
                                    src="https://www.youtube.com/embed/AyZgd6ndtYM?si=y3pOY2dSWdHJrXwb"
                                    title="YouTube video player" frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ¿Cómo Funciona (Consultor)? -->
            <div class="container mb-5">
                <div class="row mb-5">
                    <div class="col-12">
                        <h1 class="strong text-center text-grey">¿Cómo <span class="bg-orange px-3">funciona?</span></h1>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <video controls>
                            <source :src="urlWeb + '/assets/videos/funciona_consultores.mp4'" type="video/mp4">
                        </video>
                    </div>
                </div>

                <hr class="mt-5">
            </div>

            <!-- Bullets -->
            <div class="container mb-5 py-5">
                <div class="d-flex flex-row justify-content-center">
                    <div>
                        <img class="img-fluid" :src="urlWeb + '/assets/images/fotos/13.png'"
                            alt="Trabajo en equipo desarrollando proyectos">
                    </div>
                    <div class="col-lg-5">
                        <h5 class="strong text-center mb-4">¡Únete a nosotros hoy mismo y aprovechar estos beneficios</h5>
                        <ul>
                            <li>Acceso a miles de clientes en todo el mundo.</li>
                            <li>Tú decides el monto y las condiciones por tus servicios.</li>
                            <li>Ejecuta libremente el número de proyectos que desees.</li>
                            <li>Trabaja cuando quieras y desde cualquier lugar del mundo.</li>
                        </ul>
                    </div>
                </div>
                <div class="d-flex flex-row justify-content-center">
                    <div class="col-lg-5 d-flex justify-content-end flex-column">
                        <h5 class="strong text-grey text-center mb-4">¡Toma ventaja de los beneficios exclusivos al contar
                            con una membresía pagada!</h5>
                        <ul>
                            <li>Ofrecemos garantías de cumplimiento y seguridad en todas las transacciones, asegurando tu
                                tranquilidad y confianza.</li>
                            <li>Siempre sabrás el monto exacto que recibirás por el trabajo realizado, sin sorpresas ni
                                cargos ocultos.</li>
                            <li>Te notificaremos inmediatamente cuando el proyecto sea fondeado, para que puedas comenzar a
                                trabajar en él sin demora.</li>
                        </ul>
                    </div>
                    <div>
                        <img class="img-fluid" :src="urlWeb + '/assets/images/fotos/15.png'" alt="Forma de pago tarjeta de credito">
                    </div>
                </div>
            </div>

            <div class=" text-center pb-5">
                <router-link to="/Registro" class="btn btn-subscribe-lg">Suscríbete</router-link>
            </div>

            <!-- gray separator -->
            <div class="container mb-5 bg-light-grey py-3">
                <div class="row">
                    <div class="col-12">
                        <h5 class="text-orange text-center mb-0">Únete para ofrecer tus servicios como consultor
                            independiente y explotar tu
                            experiencia y conocimiento en las tecnologías SAP <br />
                            Nuestra plataforma es segura, eficiente y fácil de usar.</h5>
                    </div>
                </div>
            </div>

        </main>
        
    </div>
  </template>
    
    <script>
    import { mapState } from 'vuex'
    import Header from '@/components/Header'
    export default {
      computed:{
        ...mapState(['urlWeb'])
    },
      name: 'Consultores',
      components:{
        Header
    },
      data () {
        return {
        }
      }
    }
    </script>


// WEBPACK FOOTER //
// src/views/Home/Consultores.vue